import { render, staticRenderFns } from "./PollySettings.vue?vue&type=template&id=4f05d5ae"
import script from "./PollySettings.vue?vue&type=script&lang=ts"
export * from "./PollySettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports